// import echarts from "echarts";
import * as echarts from "echarts";
export function loadChart(myChart, obj, fontSizes) {
  myChart.setOption({
    tooltip: {
      trigger: "axis"
    },
    grid: {
      top: 30,
      right: 25,
      left: 33,
      bottom: 20
    },
    legend: {
      icon: "circle",
      top: "5%",
      right: "5%",
      itemWidth: 9,
      itemGap: 20,
      textStyle: {
        color: "#fff",
        fontSize: fontSizes
      }
    },
    xAxis: [
      {
        type: "category",
        name: "",
        boundaryGap: false,
        axisLine: {
          show: true,
          lineStyle: {
            color: "#525252",
            fontSize: fontSizes
          }
        },

        axisTick: {
          show: false,
          lineStyle: {
            color: "#fff",
            fontSize: fontSizes
          }
        },
        axisLabel: {
          color: "#fff",
          fontSize: fontSizes
        },
        data: obj.date
      }
    ],
    yAxis: [
      {
        name: "%",
        type: "value",
        nameGap: 14.5,
        min: function(value) {
          return value.min;
        },
        nameTextStyle: {
          color: "#fff",
          fontSize: fontSizes
        },
        textStyle: { color: "#fff", fontSize: fontSizes },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#034255",
            fontSize: fontSizes
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: "#fff",
          fontSize: fontSizes
        },
        splitLine: {
          lineStyle: {
            type: "dotted",
            color: "#034255"
          }
        }
      }
    ],
    series: [
      {
        name: "项目进度",
        type: "line",
        data: obj.sjData,
        color: "#08A7DA",
        smooth: true,
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "rgba(8,167,218,0.6)"
                },
                {
                  offset: 1,
                  color: "rgba(15,41,87,0.6)"
                }
              ],
              false
            )
          }
        },
        itemStyle: {
          normal: {
            opacity: 0
          }
        }
      },
      {
        name: "资金进度",
        type: "line",
        data: obj.sjData1,
        color: "#B784DE",
        smooth: true,
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "#B784DE"
                },

                {
                  offset: 1,
                  color: "rgba(15,41,87,0.6)"
                },
                {
                  offset: 1,
                  color: "rgba(15,41,87,0.6)"
                }
              ],
              false
            )
          }
        },
        itemStyle: {
          normal: {
            opacity: 0
          }
        }
      }
    ]
  });
}
